'use strict'
import moment from 'moment'

function processFieldErrors (saveResponse) {
  let errors = {}
  if (saveResponse && saveResponse.fieldErrors !== null && saveResponse.fieldErrors !== undefined) {
    for (let error of saveResponse.fieldErrors) {
      // if fieldname includes an array index, split out the index number and tag it onto the end of the fieldname
      if (error.fieldName.indexOf('[') >= 0) {
        let startIndex = error.fieldName.indexOf('[')
        let endIndex = error.fieldName.indexOf(']')
        let index = error.fieldName.substring(startIndex + 1, endIndex)
        let field = error.fieldName.substring(endIndex + 2)
        errors[field + index] = error.errorMessage
      } else {
        errors[error.fieldName] = error.errorMessage
      }
    }
  }
  return errors
}

function processSuccessMessage (saveResponse) {
  if (saveResponse.result === 'success') {
    return true
  } else {
    return false
  }
}

function processErrorMessage (saveResponse) {
  let errors = []
  if (saveResponse && saveResponse.globalErrors !== null) {
    for (let error of saveResponse.globalErrors) {
      errors.push(error)
    }
  }
  return errors
}

/**
 * Returns map of request parameters
 * @param query - window query string
 * @returns {*}
 */
function getRequestParameters (query) {
  if (!query) {
    return { }
  }

  return (/^[?#]/.test(query) ? query.slice(1) : query)
    .split('&')
    .reduce((params, param) => {
      let [ key, value ] = param.split('=')
      params[key] = value ? decodeURIComponent(value.replace(/\+/g, ' ')) : ''
      return params
    }, { })
}

// Return academic year from given string ('MM/DD/YYY') formatted date
function getAcademicYear (dateString) {
  let date = moment(dateString, 'MM/DD/YYYY')
  let year = date.year()

  if (date.month() < 6) {
    return (year - 1) + '-' + year
  } else {
    return year + '-' + (year + 1)
  }
}

function getAcademicYearFromInt (year) {
  if (year) {
    let yearStr = (year - 1) + '-' + year.toString().substring(2)
    return yearStr
  }

  return ''
}

function convertDateToString (date) {
  if (date && typeof date !== 'string' && !(date instanceof String)) {
    return date.format('MM/DD/YYYY')
  } else {
    return date
  }
}

function validateNumberPress (e, allowDecimal) {
  let keyCodeArray = [46, 8, 9, 27, 13, 110]
  if (allowDecimal) keyCodeArray.push(190)
  // Allow: backspace, delete, tab, escape, enter and .
  if (keyCodeArray.indexOf(e.keyCode) !== -1 ||
    // Allow: Ctrl/cmd+A
    (e.keyCode === 65 && (e.ctrlKey === true || e.metaKey === true)) ||
    // Allow: Ctrl/cmd+C
    (e.keyCode === 67 && (e.ctrlKey === true || e.metaKey === true)) ||
    // Allow: Ctrl/cmd+X
    (e.keyCode === 88 && (e.ctrlKey === true || e.metaKey === true)) ||
    // Allow: home, end, left, right
    (e.keyCode >= 35 && e.keyCode <= 39)) {
    // let it happen, don't do anything
    return
  }
  // Ensure that it is a number and stop the keypress
  if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
    e.preventDefault()
  }
}

export default {
  processFieldErrors: processFieldErrors,
  processSuccessMessage: processSuccessMessage,
  processErrorMessage: processErrorMessage,
  getRequestParameters: getRequestParameters,
  getAcademicYear: getAcademicYear,
  getAcademicYearFromInt: getAcademicYearFromInt,
  convertDateToString: convertDateToString,
  validateNumberPress: validateNumberPress
}
